module.exports = __webpack_public_path__ + "img/team-1-4.3cdcc40b.jpeg";